import { Component, OnInit } from '@angular/core';
import { preserveWhitespacesDefault } from '@angular/compiler';

@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.css']
})
export class ChatbotComponent implements OnInit {

  constructor() { }
  chat;
  ngOnInit() {
    
  }
  kargall(){
    var xhr=new XMLHttpRequest();
    var a="https://acobot-brainshop-ai-v1.p.rapidapi.com/get?bid=178&key=sX5A2PcYZbsN5EY6&uid=mashape&msg=";
    var c=a+this.chat;
    var ch=this.chat;
    xhr.open("GET", c);
    xhr.setRequestHeader("x-rapidapi-host", "acobot-brainshop-ai-v1.p.rapidapi.com");
    xhr.setRequestHeader("x-rapidapi-key", "23afcb7ce7msh54dd1061c86521cp1c66bejsn627983c745fb");
    xhr.onreadystatechange=test;
    function test(){
     if(this.status==200 && this.readyState==4){
         var res_data=JSON.parse(this.responseText);
         console.log(res_data);
        //  var ans=document.getElementById('etherakh');
        //  ans.innerHTML=res_data.cnt;
        if(ch=="hi"||ch=="hello"||ch=="hey"||ch=="Hi"||ch=="Hello"||ch=="Hey"){
          document.getElementById("add_to_me").innerHTML +="</br>"+"You: "+ch+"</br>"+
          "Hello, how can we help you?";
        }
        else if(ch=="I want to know about the plans"||ch=="What plans do you have?"||ch=="fitness plans"||
        ch=="i want to know about the plans"||ch=="what plans do you have?"||ch=="Fitness plans"||ch=="Fitness Plans"||
        ch=="bodybuilding plans"||ch=="Bodybuilding plans"||ch=="fitness plans"||ch=="Bodybuilding Plans"||ch=="bodybuilding Plans"||ch=="Plans"||ch=="plans"){
          document.getElementById("add_to_me").innerHTML +="</br>"+"You: "+ch+"</br>"+
          "We have three plans: Beginner, Intermediate and Advanced plans. Click on become a member on our website to subscribe to any of them.";
        }
        else if(ch=="fatloss"||ch=="fatloss guide"||ch=="Fatloss programs"||ch=="Are fatloss programs available?"||
        ch=="muscle building"||ch=="muscle building guide"||ch=="Muscle building programs"||ch=="Are muscle building programs available?"||
        ch=="FatLoss"||ch=="Fat Loss"||ch=="Fat loss"||ch=="MuscleBuilding"||ch=="Muscle Building"){
          document.getElementById("add_to_me").innerHTML +="</br>"+"You: "+ch+"</br>"+
          "Yes, you can check our website for the programs.";
        }
        else if(ch=="Contact"||ch=="contact"||ch=="How can I contact you?"||ch=="how can i contact you?"||
        ch=="I have queries"||ch=="I want to talk to you"||ch=="I want to message you"){
          document.getElementById("add_to_me").innerHTML +="</br>"+"You: "+ch+"</br>"+
                  "You can contact us at +91 9915902685, +91 7973245205.";
        }
        else{
         document.getElementById("add_to_me").innerHTML +="</br>"+"You: "+ch+"</br>"+
                  "" +res_data.cnt+"";
        }
        
        
     }
    }
    xhr.send();
    }
  

}
